import { render, staticRenderFns } from "./declarationInformation.vue?vue&type=template&id=6288519a&scoped=true&"
import script from "./declarationInformation.vue?vue&type=script&lang=js&"
export * from "./declarationInformation.vue?vue&type=script&lang=js&"
import style0 from "./declarationInformation.vue?vue&type=style&index=0&id=6288519a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288519a",
  null
  
)

export default component.exports